// import { addError } from "../state/errorSlice";
// import store from "../state/store";
import { AggregateValidationError } from "./AggregateValidationError";
import { BaseError } from "./BaseError";

export default class ErrorService {
  static displayError(error: BaseError) {
    console.error(error.toIBaseError());
    // store.dispatch(addError(error.toIBaseError()));
  }

  static reportError(error: any, displayError: boolean = false) {
    if (error instanceof BaseError) {
      error.handleError();
      if (displayError) {
        this.displayError(error);
      }
    } else if (error instanceof AggregateValidationError) {
      error.errorList.forEach((e) => {
        e.handleError();
        if (displayError) {
          this.displayError(e);
        }
      });
    } else {
      console.error(error);
    }
  }
}
